import { User } from "@/types/Sidebar.type";

const TOKEN_KEY = "aiclintract_auth_token";
const REFRESH_TOKEN_KEY = "aiclintract_refresh_token";
const USER_KEY = "aiclintract_user";
const REGULATORY_TAB_KEY = "regulatory-active-tab";

export const getToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

export const getRefreshToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setRefreshToken = (token: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const clearToken = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem("selectedStudyId");
  localStorage.removeItem(REGULATORY_TAB_KEY);
};

export const getStoredUser = (): User | null => {
  if (typeof window === "undefined") {
    return null;
  }
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

export const setStoredUser = (user: User): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const parts = token.split(".");
    if (parts.length < 2 || !parts[1]) {
      return true;
    }
    const payload = JSON.parse(atob(parts[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

// Consumer token functions removed — Kong API Gateway now injects
// x-consumer-id and x-tenant-id headers after JWT validation.
// Use getStoredUser()?.id if you need the current user's UUID.
